{
  "title": "New to BJJ? Start here.",
  "date": "2026-06-01",
  "category": "Academy",
  "excerpt": "No experience and no special fitness level are required for your first class.",
  "body": "Choose your preferred dojo and send us a short message. We will recommend a beginner-friendly class, explain what to wear and welcome you when you arrive. You can start at any age and build fitness as you learn.",
  "image": "/images/hero.jpg",
  "featured": false
}
